module.exports = __webpack_public_path__ + "static/media/flo2min-min.5b422524.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/floristics/flo2min-min.jpg
// module id = 239
// module chunks = 0